import React from 'react'
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button, Table
} from 'reactstrap'
import {Query} from 'react-apollo'
import {sumBy} from 'lodash'

import QUERY from '../../../queries/server/project_activity_user_time';

const {format} = Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP'
})

const ProjectActivityUserTimeModal = ({id, isOpen, toggle, title}) => {

  if(!id) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader>{title}</ModalHeader>
      <ModalBody style={{'white-space': 'pre-line'}}>

        <Query query={QUERY} variables={{id}}>
            {({data, loading, error}) => {

                if (loading) return <h1>Loading...</h1>

                const formattedData = data.project_activity_budget.user_project_activities.reduce((carry, record) => {

                  if(carry[record.user.user_id]) {
                    carry[record.user.user_id].total_hours += sumBy(
                      record.timesheets, 
                      ({hours_worked}) => hours_worked
                    )
                    carry[record.user.user_id].total_rate += sumBy(
                      record.timesheets, 
                      ({role_hourly_rate, hours_worked}) => role_hourly_rate * hours_worked
                    )
                  } else {
                    carry[record.user.user_id] = {
                      user: record.user,
                      total_hours: sumBy(
                        record.timesheets, 
                        ({hours_worked}) => hours_worked
                      ),
                      total_rate: sumBy(
                        record.timesheets, 
                        ({role_hourly_rate, hours_worked}) => role_hourly_rate * hours_worked
                      )
                    }
                  }

                  return carry
                }, {})


                return (
                  <Table hover>
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Hours Worked</th>
                        <th>Budget Used</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formattedData && Object.keys(formattedData).map(key => {
                        const record = formattedData[key];
                        return (
                          <tr>
                            <td>{record.user.full_name}</td>
                            <td>{record.total_hours}</td>
                            <td>{format(record.total_rate)}</td>
                          </tr>
                        )
                      } )}
                    </tbody>
                  </Table>
                )
            }}
        </Query>

      </ModalBody>
      <ModalFooter>
        <Button block size="sm" color="primary" onClick={toggle}>Ok</Button>
      </ModalFooter>
    </Modal>
  )
}

export default ProjectActivityUserTimeModal